import { defineMessages } from 'react-intl';

const messages = defineMessages({
  textWithBlocks: {
    id: 'Text with Blocks',
    defaultMessage: 'Text with Blocks',
  },
  headline: {
    id: 'Headline',
    defaultMessage: 'Headline',
  },
  text: {
    id: 'Text',
    defaultMessage: 'Text',
  },
  buttonLabel: {
    id: 'Button label',
    defaultMessage: 'Button label',
  },
  buttonLink: {
    id: 'Button link',
    defaultMessage: 'Button link',
  },
});

export const TextWithBlocksSchema = (props) => {
  const { intl } = props;

  return {
    title: intl.formatMessage(messages.textWithBlocks),
    block: 'textWithBlocks',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['headline', 'text', 'buttonLabel', 'buttonLink'],
      },
    ],
    properties: {
      headline: {
        title: intl.formatMessage(messages.headline),
      },
      text: {
        title: intl.formatMessage(messages.text),
        widget: 'richtext',
      },
      buttonLabel: {
        title: intl.formatMessage(messages.buttonLabel),
      },
      buttonLink: {
        title: intl.formatMessage(messages.buttonLink),
        widget: 'object_browser',
        mode: 'link',
        allowExternals: true,
      },
    },
    required: [],
  };
};
